import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";

export const bsConfig: Partial<BsDatepickerConfig> = {
  adaptivePosition: true,
  containerClass: 'theme-default',
  isAnimated: true,
  rangeInputFormat: 'DD/MM/YYYY',
  dateInputFormat: 'DD/MM/YYYY',
  showWeekNumbers: false
}